
import { defineComponent, ref, onMounted } from 'vue'
import {
    useRoute
} from 'vue-router';
import pservice from '@/core/services/PublicService';

export default defineComponent({
    name: "public-sport-winscore",
    setup() {
        const route = useRoute();
        const { idevent, idsport } = route.params
        const link = ref<any>(null)

        const getMore = async () => {
            //loading.value = true
            await pservice.more({
                    evento: idevent,
                    sport: idsport
                })
                .then((res) => {
                    //loading.value = false
                    getLink(res.data.event.idevent)
                }).catch(({
                    response
                }) => {
                    //loading.value = false
                })
        }


        const getLink = (ideve) => {
            switch (idsport) {
                case 'basquetbol-damas':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/3/fechas`
                    break;
                case 'basquetbol-varones':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/4/fechas`
                    break;
                case 'futbol-masculino': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/5/fechas`
                    break;
                case 'futsal-damas': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/6/fechas`
                    break;
                case 'futsal-varones': //ok
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/7/fechas`
                    break;
                case 'voleibol-damas':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/16/fechas`
                    break;
                case 'voleibol-varones':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/17/fechas`
                    break;
                case 'futbol-femenino':
                    link.value = `https://winscore.perufedup.com/publico/campeonatos/${ideve}/categorias/42/fechas`
                    break;
            }
        }

        onMounted(() => {
            getMore()
        })

        return {
            link,
            getMore

        }
    },
})
